<template>
  <div class="auth-wrapper auth-v1">
    <div class="auth-inner">
      <b-card class="m-0 py-1 h-100">
        <!-- Brand -->
        <div class="d-flex justify-content-center">
          <b-img src="@/assets/images/logo/default.png" alt="logo" style="width: 100px; height: 100px;" />
        </div>
        <div class="brand-logo w-100 flex-column align-items-center justify-content-center">
          <h1 class="brand-text text-primary">پنل منوتِک</h1>
        </div>
        <!-- /Brand logo-->
        <div class="px-1">
          <b-card-text class="text-primary-middle font-weight-bolder mb-50">کد تایید را وارد کنید</b-card-text>
          <b-card-text class="text-primary-middle mb-2">کد تایید برای شماره {{ loginData.phoneNumber }} پیامک
            شد</b-card-text>


          <!-- form -->
          <b-form class="auth-login-form" @submit.prevent>
            <CodeInput v-model="loginData.code" :loading="false" :fieldWidth="50" :fieldHeight="50" class="input"
              dir="ltr" />
            <div class="text-center my-1">
              <b-button variant="white" :disabled="!counterEnded" @click.prevent="sendCode"
                class="btn btn-no-focus font-weight-bolder text-secondary">
                <div class="text-main" v-if="!startCounter">
                  <feather-icon icon="RotateCcwIcon" />
                  <span class="mx-1">ارسال مجدد</span>
                </div>
                <countdown v-if="startCounter" @end="checkCounterEndTime" :time="timerCount">
                  <template slot-scope="props"> {{ props.minutes }}:{{ props.seconds }} مانده تا دریافت مجدد
                    کد</template>
                </countdown>
              </b-button>
            </div>

            <!-- submit buttons -->
            <b-button type="submit" variant="primary" block @click="loginWithOtp"
              :disabled="loading || loginData.code.length !== 5"
              class="d-flex align-items-center justify-content-center mt-1 py-1">
              <span>تایید</span>
              <b-spinner v-if="loading" variant="white" class="ml-50" small></b-spinner>
            </b-button>
            <b-button @click.prevent="goBackLogin" type="submit" variant="outline-primary" block
              class="mt-2 py-1">ویرایش
              شماره</b-button>
          </b-form>
        </div>
      </b-card>
    </div>
  </div>
</template>

<script>
/* eslint-disable global-require */
import { ValidationProvider, ValidationObserver } from 'vee-validate';
// eslint-disable-next-line object-curly-newline
import { BRow, BCol, BLink, BFormGroup, BFormInput, BInputGroupAppend, BInputGroup, BFormCheckbox, BCard, BCardText, BCardTitle, BImg, BForm, BButton, BSpinner } from 'bootstrap-vue';
import CodeInput from '@core/components/code-verifier';
import { togglePasswordVisibility } from '@core/mixins/ui/forms';
import store from '@/store/index';

export default {
  components: {
    BRow,
    BCol,
    BLink,
    BSpinner,
    BFormGroup,
    BFormInput,
    BInputGroupAppend,
    BInputGroup,
    BFormCheckbox,
    BCardText,
    BCardTitle,
    BImg,
    BForm,
    BButton,
    CodeInput,
    BCard,
    ValidationProvider,
    ValidationObserver,
  },
  data() {
    return {
      loading: false,
      loginData: {
        phoneNumber: '',
        code: '',
      },
      counterEnded: false,
      startCounter: false,
      // timerCount: 1 * 10 * 1000,
      timerCount: 2 * 60 * 1000,
      sideImg: require('@/assets/images/pages/login.svg'),
      // validation rulesimport store from '@/store/index'
    };
  },
  mixins: [togglePasswordVisibility],
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon';
    },
    imgUrl() {
      if (store.state.appConfig.layout.skin === 'dark') {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.sideImg = require('@/assets/images/pages/login.svg');
        return this.sideImg;
      }
      return this.sideImg;
    },
  },
  methods: {
    sendCode() {
      this.$auth
        .sendCode({
          phoneNumber: this.loginData.phoneNumber,
        })
        .then((res) => {
          this.startCounter = true;
          this.counterEnded = false;
        })
        .catch((err) => {
          this.$notif({ type: 'error' });
        });
    },
    async loginWithOtp() {
      try {
        this.loading = true;
        await this.$auth
          .loginWithOtp(this.loginData)
          .then((res) => {
            setTimeout(() => {
              this.$auth.$storage.removeLocalStorage('loginMobile');
              this.$router.push('/');
            }, 850)
          })
          .catch(() => {
            this.loading = false;
          });
      }
      catch (err) {

      }
    },
    checkCounterEndTime() {
      this.counterEnded = true;
      this.startCounter = false;
    },
    checkPhoneSetup() {
      const phoneSetupStatus = this.$auth.$storage.getLocalStorage('loginMobile') || false;
      if (!phoneSetupStatus) {
        this.$router.push('/login');
      } else {
        this.loginData.phoneNumber = this.$auth.$storage.getLocalStorage('loginMobile');
        this.startCounter = true;
      }
    },
    goBackLogin() {
      this.$auth.$storage.removeLocalStorage('loginMobile');
      this.$router.push('/login');
    },
  },
  mounted() {
    this.checkPhoneSetup();
  },
};
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';
</style>
